import { Component, ContentChild, Input, OnDestroy } from '@angular/core'
import { appPopoverDirective } from '@app/modules/culture/events/components/gate-statsbox/gate-statsbox.component'
import { MenuItem } from 'primeng/api'

@Component({ selector: 'app-menu', templateUrl: './menu.component.html', styleUrls: ['./menu.component.scss'], standalone: false })
export class MenuComponent implements OnDestroy {
  /** Menu content child */
  @ContentChild(appPopoverDirective) menuContent!: appPopoverDirective

  /** Menu item */
  @Input() menu: MenuItem[]

  /** Popover left in pixels */
  @Input() left: number

  /** Popover top in pixels */
  @Input() top: number


  ngOnDestroy() {
    // Clean up any content child references
    if (this.menuContent) {
      this.menuContent = null as any
    }
  }
}
